module.exports = __webpack_public_path__ + "static/media/no_data.9d62fa0f.svg";